import { render, staticRenderFns } from "./Handling.vue?vue&type=template&id=1f16449c&scoped=true"
import script from "./Handling.vue?vue&type=script&lang=js"
export * from "./Handling.vue?vue&type=script&lang=js"
import style0 from "./Handling.vue?vue&type=style&index=0&id=1f16449c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f16449c",
  null
  
)

export default component.exports